// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { getAccountInquiry, GetAccountInquiryApiParameter } from "@keller/App/Services/AccountInquiryService";
import { AccountInquiryModal } from "@keller/App/Store/Reducers/xAccountInquiry";

type HandlerType = ApiHandler<GetAccountInquiryApiParameter & HasOnSuccess & HasOnError<string>, AccountInquiryModal>;

export const DispatchBeginLoadAccountInquiry: HandlerType = props => {
    props.dispatch({
        type: "xAccountInquiry/BeginLoadAccountInquiry" as any,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, onError, ...apiParameter } = props.parameter;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getAccountInquiry(props.apiParameter);
    } catch (error) {
        const failedMessage =
            error.errorMessage || "Please try again and contact support if you continue to have issues.";
        props.parameter.onError?.(failedMessage);
        props.dispatch({ type: "xAccountInquiry/FailedToLoadAccountInquiry", failedMessage } as any);
        return false;
    }
};

export const DispatchCompleteLoadAccountInquiry: HandlerType = props => {
    props.dispatch({
        type: "xAccountInquiry/CompleteLoadAccountInquiry",
        data: props.apiResult,
    } as any);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [
    DispatchBeginLoadAccountInquiry,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadAccountInquiry,
    ExecuteOnSuccessCallback,
];

const loadAllAccountInquiry = createHandlerChainRunner(chain, "loadAllAccountInquiry");

export { loadAllAccountInquiry };
